import React, { useState, useRef } from "react";
import { motion, scale, useDragControls } from "framer-motion";
import { ExternalLink } from "lucide-react";
import "./styles/DraggableModalWrapper.css";

const DraggableFileViewer = ({ fileUrl, mime, onClose }) => {
  const nodeRef = useRef(null);
  const dragControls = useDragControls();
  const filename = fileUrl.split("/").pop();
  const [pointerDown, setPointerDown] = useState(false);

  return (
    <div className="draggable-modal-backdrop" ref={nodeRef}>
      <motion.div
        className="draggable-modal"
        drag
        dragControls={dragControls}
        dragListener={false}
        dragMomentum={false}
        dragElastic={0.2}
        dragConstraints={nodeRef}
        dragTransition={{ bounceStiffness: 600, bounceDamping: 15 }}
        initial={{ opacity: 0, scale: 0.95, y: -20 }}
        animate={{
          opacity: 1,
          scale: pointerDown ? 0.98 : 1,
          y: 0,
        }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        transition={{ duration: 0.25, ease: "easeInOut" }}
        onDragStart={() => setPointerDown(true)}
        onDragEnd={() => setPointerDown(false)}
      >
        <motion.div
          className="draggable-modal-header"
          onPointerDown={(e) => dragControls.start(e)}
          style={{ cursor: pointerDown ? "grabbing" : "grab" }}
        >
          <span>⠿ {filename}</span>
          <div className="window-controls">
            <a
              href={fileUrl}
              target="_blank"
              rel="noreferrer"
              className="open-in-new-tab"
            >
              <ExternalLink color="white" width={22} height={22} />
            </a>
            {onClose && (
              <button className="draggable-modal-close" onClick={onClose}>
                ✖
              </button>
            )}
          </div>
        </motion.div>
        <div className="dfv-content">
          {mime.startsWith("image") && <img src={fileUrl} alt={filename} />}
          {mime.startsWith("video") && <video src={fileUrl} controls />}
          {mime === "application/pdf" && (
            <iframe src={fileUrl} title={filename} />
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default DraggableFileViewer;
